/**
 * Core props/eVars set once on the AppMeasurement singleton and expected on every beacon.
 * Page views (`t()`) send these automatically, but link-tracking calls (`tl()`) only
 * transmit variables listed in `linkTrackVars`, so every `tl()` caller must include these
 * to avoid dropping core values (application, country, language, dealer identity, user).
 */
export const CORE_LINK_TRACK_VARS = "prop2,prop3,prop4,prop6,eVar2,eVar3,eVar6,eVar7,eVar8,eVar199,eVar200"
